export const FEATURE_FLAG__BEGIN_15 = 'begin15';



// WEBPACK FOOTER //
// ./src/constants/featureflags.js